import { EGiftOrderStatuses } from '../const'
type Type = 'DEFAULT' | 'GIFT_TYPE_BONUS_CROWNS_REVIEW_SCREENSHOT'
const statusMap: Record<
  string,
  Partial<Record<EGiftOrderStatuses, EGiftOrderStatuses[]>>
> = {
  DEFAULT: {
    [EGiftOrderStatuses.NEW]: [
      EGiftOrderStatuses.CANCELED,
      EGiftOrderStatuses.IN_PROGRESS,
    ],
    [EGiftOrderStatuses.IN_PROGRESS]: [
      EGiftOrderStatuses.SENT,
      EGiftOrderStatuses.CANCELED,
    ],
  },
  GIFT_TYPE_BONUS_CROWNS_REVIEW_SCREENSHOT: {
    [EGiftOrderStatuses.NEW]: [
      EGiftOrderStatuses.CANCELED,
      EGiftOrderStatuses.SENT,
    ],
  },
}

export const getGiftOrderDetailsStatus = (
  status: EGiftOrderStatuses,
  typeGift?: string,
): EGiftOrderStatuses[] => {
  const type: Type =
    typeGift === 'GIFT_TYPE_BONUS_CROWNS_REVIEW_SCREENSHOT'
      ? typeGift
      : 'DEFAULT'

  return statusMap[type][status] ?? []
}
